import * as React from "react";
import { connect } from "react-redux";
import { ApplicationState, ConnectedReduxProps } from "@reducers/index";
import { User } from "@models/user";
import { deleteRequest, fetchRequest } from "@actions/user";
import UsersTable from "@components/users/Table";
import { Button, Card } from "antd";
import TableRenderer from "@hocs/TableRenderer";
import UserForm from "@components/users/Form";
import { FormattedMessage } from "react-intl";
import { getUsersList } from "@reducers/user";
import SearchUsersComponent from "../../components/users/Search";
import { NavLink } from "react-router-dom";

interface PropsFromState {
  loading: boolean;
  data: User[];
  errors?: string;
  count: number;
}

interface PropsFromDispatch {
  fetchRequest: typeof fetchRequest;
  deleteRequest: typeof deleteRequest;
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class UsersIndexPage extends React.Component<AllProps> {
  deleteUser = (item: User): any => {
    this.props.deleteRequest({
      params: {
        id: item.id
      }
    });
  };

  render() {
    const { loading, data, search, currentPage } = this.props;
    return (
      <div>
        <div className={`toggle-button-wrapper`}>
          <NavLink to={`/users/create`}>
            <Button type={"primary"}>
              <FormattedMessage
                id="app.create_new_user"
                defaultMessage={`Create User`}
              />
            </Button>
          </NavLink>
        </div>
        <div className={"page-table-wrapper"}>
          <Card className={`page-table-header`} bordered={false}>
            <SearchUsersComponent search={search} />
          </Card>

          <UsersTable
            data={data}
            currentPage={currentPage}
            rowKey={record => record.id}
            deleteFn={this.deleteUser}
            loading={loading}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ users }: ApplicationState) => ({
  loading: users.loading,
  data: getUsersList(users),
  count: users.count
});

const mapDispatchToProps = {
  fetchRequest,
  deleteRequest
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TableRenderer(UsersIndexPage));
